import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import {
  knmSetErknmKnoOrganizationFormValue,
  knmSetErknmSupervisionTypeFormValue,
  knmSetErknmKnmKindVersionIdFormValue,
  knmSetTypeFormValue,
  knmSetErknmReasonFormValue,
  knmSetTypeErvkFormValue,
} from 'KnmPackage/MainModule/actions/knmActions';

import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';

export function useKnmErknm(values: IKnmErknmForm) {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const formKnoOrganization = values.knoOrganizationErknm;
  const formSupervisionType = values.kindControl;
  const formKnmKindDictVersionId = values.kindKnm?.value.dictVersionId;
  const formType = values.typeErknm;
  const formReasons = values.reasonsErknm;

  const setKnoOrganizationFormValue = useCallback(() => {
    dispatch(knmSetErknmKnoOrganizationFormValue(formKnoOrganization));
  }, [dispatch, formKnoOrganization]);

  useEffect(() => {
    setKnoOrganizationFormValue();
  }, [setKnoOrganizationFormValue]);

  const setSupervisionTypeFormValue = useCallback(
    () => dispatch(knmSetErknmSupervisionTypeFormValue(formSupervisionType)),
    [dispatch, formSupervisionType],
  );

  useEffect(() => {
    setSupervisionTypeFormValue();
  }, [setSupervisionTypeFormValue]);

  const setKnmKindFormValue = useCallback(
    () => dispatch(knmSetErknmKnmKindVersionIdFormValue(formKnmKindDictVersionId)),
    [dispatch, formKnmKindDictVersionId],
  );

  useEffect(() => {
    setKnmKindFormValue();
  }, [setKnmKindFormValue]);

  const setTypeFormValue = useCallback(() => {
    dispatch(knmSetTypeFormValue(formType));
    dispatch(knmSetTypeErvkFormValue(formType));
  }, [dispatch, formType]);

  useEffect(() => {
    setTypeFormValue();
  }, [setTypeFormValue]);

  const setReasonsFormValue = useCallback(() => {
    dispatch(knmSetErknmReasonFormValue(formReasons));
  }, [dispatch, formReasons]);

  useEffect(() => {
    setReasonsFormValue();
  }, [setReasonsFormValue]);
}
